module.exports = __webpack_public_path__ + "img/LTC.baf0a02c.svg";